module.exports = require("@prisma/client/runtime/client");